import { defineStore } from 'pinia'
import { watch } from 'vue'
import { useLocalStorage } from '@vueuse/core'

export const useThemeStore = defineStore('theme', () => {
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const theme = useLocalStorage('theme', prefersDark ? 'dark' : 'light')

  function apply(t) {
    if (t === 'light') {
      document.documentElement.setAttribute('data-theme', 'light')
    } else {
      document.documentElement.removeAttribute('data-theme')
    }
  }

  function toggle() {
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
  }

  watch(theme, apply, { immediate: true })

  return { theme, toggle }
})
